import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ListTypeComponent = () => {
  const { modelId } = useParams(); // Pobieranie modelId z URL
  const navigate = useNavigate();

  // Definiowanie stanu dla listTypes i setListTypes
  const [listTypes, setListTypes] = useState([]);

  useEffect(() => {
    async function fetchListTypes() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/list-type/${modelId}`);
        setListTypes(response.data); // Ustawianie danych listy typów
      } catch (error) {
        console.error("Błąd podczas pobierania listy typów:", error);
      }
    }

    fetchListTypes();
  }, [modelId]); // Dependencja na modelId, dzięki czemu useEffect uruchamia się ponownie gdy modelId się zmienia

  return (
  <div className="app-container">
    <div className="sidebar">
     <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />

  <div className="menu">
 
    <ul>
         <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
    </ul>
</div>
    </div>
    <div className="content">
                    <button onClick={() => navigate(-1)} className="back-button">Wstecz</button>

    <div className="katalog">
      <h1>Lista Typów</h1>
      <ul>
        {listTypes.map(listType => (
    
        
                 <li key={listType._id} className="type-item">
          <div className="type-image">

          </div>
          <div className="type-info">
            <Link to={`/spare-part-list/${listType._id}`} className="type-link">
              {listType.nazwa}
            </Link>
          </div>
        </li>
      ))}
        
        
      </ul>
    </div>
    </div>
    </div>
  );
}

export default ListTypeComponent; // Eksportowanie komponentu (nazwa zmieniona na ListTypeComponent, aby uniknąć konfliktów)
